module.exports = __webpack_public_path__ + "img/tarde_2@2x.54e5ba96.jpg";